module.exports = __webpack_public_path__ + "assets/SquareByOppMidpoints.4237244395f35ffd63520a643866b07a.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/SquareByOppMidpoints.gmt
// module id = 999
// module chunks = 0